import { computed, onScopeDispose, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useQueryClient } from '@tanstack/vue-query'
import { useAuthStore } from '@/stores/auth'
import { useClubStore } from '@/stores/club'
import type { TryoutHomeResponse } from '@/api/tryoutHome'

const roleOrder = ['owner', 'admin', 'headcoach', 'assistantcoach', 'programcoach', 'selector', 'support', 'athlete', 'parent', 'member'] as const
export function useCurrentRoles() {
  const route = useRoute(), auth = useAuthStore(), clubs = useClubStore(), client = useQueryClient()
  const revision = ref(0)
  onScopeDispose(client.getQueryCache().subscribe(event => {
    if (event.query.queryKey[0] === 'tryoutHome') revision.value++
  }))
  const context = computed(() => {
    void revision.value
    const clubId = String(route.params.clubId || ''), seasonId = String(route.params.seasonId || ''), eventId = String(route.params.tryoutId || '')
    if (eventId) {
      // Observe the viewer-scoped home query already owned by EventViewBoundary.
      // Never substitute club grants or the previous event's roles while loading.
      const query = client.getQueryState<TryoutHomeResponse>(['tryoutHome', seasonId, eventId, clubId, auth.user?.details?.id || auth.user?.id || ''])
      const home = query?.status === 'success' && query.data?.event.id === eventId ? query.data : undefined
      return { name: home?.event.title || '', flags: home?.event.roles || {} }
    }
    const club = clubId ? clubs.data[clubId] : undefined
    return { name: club?.name || '', flags: club || {} }
  })
  const roles = computed(() => {
    const flags = context.value.flags as Record<string, unknown>
    const result: string[] = roleOrder.filter(role => flags[role] === true)
    if (auth.user?.details?.systemAdmin === true) result.push('systemAdmin')
    return result
  })
  return { roles, contextName: computed(() => context.value.name) }
}
